import session from './session'
import { rootAPI } from './settings'

const fetchTagList = params => {
  return session.get(rootAPI + 'tags', { params })
}

const fetchArchivedTagList = params => {
  console.log('Fetching archived tags from:', rootAPI + 'tags/archived')
  return session.get(rootAPI + 'tags/archived', { params })
}

const getTagById = tagId => {
  return session.get(rootAPI + `tags/${tagId}`)
}

const createTag = params => {
  return session.post(rootAPI + 'tags/', params)
}

const updateTag = (tagId, params) => {
  return session.put(rootAPI + `tags/${tagId}/`, params)
}

const restoreTag = tagId => {
  return session.put(rootAPI + `tags/${tagId}/restore`, {})
}

const deleteTag = tagId => {
  return session.delete(rootAPI + `tags/${tagId}/`)
}

export { fetchTagList, fetchArchivedTagList, getTagById, createTag, updateTag, restoreTag, deleteTag }
